"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIScreenTypeValidation = void 0;
class ChargerUIScreenTypeValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 7)) {
            return false;
        }
        return true;
    }
}
exports.ChargerUIScreenTypeValidation = ChargerUIScreenTypeValidation;
